import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";

export const SchedulingMethodField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["4", "12", "13", "14"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="schedulingMethod"
        fullWidth
        label={t(translationPath + "schedulingMethod") || "schedulingMethod"}
      />
      <FormHelperText>
        {t(translationPath + "schedulingMethodMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
